<template>
  <div>
    <datepicker :format="DatePickerFormat" minimum-view="year" v-model="localValue"></datepicker>
  </div>
</template>

<script>
  import Datepicker from 'vuejs-datepicker'
  import customMixin from '@/mixins/customMixin'
  export default {
    name:'VbdatapickerYear',
    props:{
      value: {
        type: String, 
			},
      
    },
    mixins : [customMixin],
    components: {
      Datepicker
    },
    data: function(){
      return{
        localValue: this.value,
        DatePickerFormat: 'yyyy',
        
        
        
      }//return
    },
    mounted(){
     //
    },
    watch:{
			localValue (newValue) {
		    this.$emit('input', newValue)
			},
			value (newValue) {
       	this.localValue = newValue
     	}
		},
    methods:{
      //
    }
    
        
  }
</script>

<style lang="scss" scoped>

</style>